(function () {
  const root = document.querySelector('.bb-moodboard');
  if (!root) return;

  const form = root.querySelector('#bbMoodboardForm');
  const field = root.querySelector('#bbmStyleDetails');
  if (!form || !field) return;

  const webhook = root.dataset.webhook || '';
  const inlineError = root.querySelector('#bbmStyleDetailsError');
  const generalMessage = root.querySelector('#bbmMessage');
  const help = root.querySelector('#bbmStyleDetailsHelp');

  if (help) {
    help.textContent = 'Beschrijf alleen interieurwensen, zoals kleuren, materialen, sfeer, wandafwerking, vloer, verlichting, raamdecoratie of accessoires. Mensen, dieren, tekst en andere scènes worden niet gebruikt.';
  }

  const blockedPatterns = [
    /\b(mens|mensen|persoon|personen|man|mannen|vrouw|vrouwen|kind|kinderen|baby|baby's|jongen|jongens|meisje|meisjes)\b/i,
    /\b(person|people|man|men|woman|women|child|children|baby|babies|boy|boys|girl|girls)\b/i,
    /\b(dier|dieren|huisdier|huisdieren|hond|honden|kat|katten|paard|paarden)\b/i,
    /\b(animal|animals|pet|pets|dog|dogs|cat|cats|horse|horses)\b/i,
    /\b(tekst|text|logo|logo's|naam|namen|letter|letters|bord|borden|sign|signs)\b/i,
    /\bexplos(?:ie|ies|ief|ieven|ion|ions)\b/i,
    /\bbom(?:men)?\b/i,
    /\bbomb(?:s|ing)?\b/i,
    /\bdynamiet\b/i,
    /\bgranaat\b/i,
    /\bgrenade\b/i,
    /\bwapen(?:s)?\b/i,
    /\bweapon(?:s)?\b/i,
    /\bgeweer\b/i,
    /\bpistool\b/i,
    /\brifle\b/i,
    /\bgun\b/i,
    /\bbloed\b/i,
    /\bblood\b/i,
    /\bgore\b/i,
    /\bmoord\b/i,
    /\bmurder\b/i,
    /\blijk(?:en)?\b/i,
    /\bcorpse\b/i,
    /\bzombie(?:s)?\b/i,
    /\boorlog\b/i,
    /\bwar\b/i,
    /\bgeweld\b/i,
    /\bviolence\b/i,
    /\bverniel(?:d|en|ing)?\b/i,
    /\bdestruction\b/i,
    /\bverwoest(?:en|ing)?\b/i,
    /\bdestroy(?:ed|ing)?\b/i,
    /\bkapot\b/i,
    /\bbeschadig(?:d|de|en|ing)?\b/i,
    /\bchaos\b/i,
    /\bapocaly(?:ps|ptisch|ptic)\b/i,
    /\bafgebrand\b/i,
    /\bbrandend(?:e)?\b/i,
    /\bbrandstichting\b/i,
    /\bvuurzee\b/i,
    /\bfire\b/i,
    /\bterror(?:isme|ist|ists)?\b/i,
    /\bseks(?:ueel|uele)?\b/i,
    /\bsexual\b/i,
    /\bporno(?:grafie)?\b/i,
    /\bporn\b/i,
    /\bnaakt\b/i,
    /\bnude\b/i,
    /\bdrugs?\b/i,
    /\bcoca(?:ine|ïne)\b/i,
    /\bhero(?:ine|ïne)\b/i,
    /\bmeth\b/i,
    /\b(negeer|ignore|jailbreak|omzeil|bypass)\b/i,
    /\b(system|developer|assistant)\s+(prompt|instructie|instruction)\b/i,
    /\b(prompt|instructie|instructions?|regels?|rules?)\s+(negeer|ignore|omzeil|bypass)\b/i,
    /\b(genereer|generate|create|voeg\s+toe|add|verwijder|remove)\b/i
  ];

  const stylePattern = /\b(kleur(?:en)?|tint(?:en)?|kleurenpalet|palet|beige|taupe|crème|creme|wit|zwart|grijs|groen|blauw|roze|rood|bruin|terracotta|oker|goud|zilver|materiaal|materialen|hout|houten|eiken|walnoot|steen|beton|marmer|messing|koper|metaal|metalen|glas|linnen|wol|katoen|velours|velvet|leer|wand|wanden|muur|muren|accentmuur|behang|stucwerk|vloer|parket|laminaat|gordijn|gordijnen|raamdecoratie|jaloezie|jaloezieën|verlichting|lamp|lampen|licht|daglicht|indirecte|hanglamp|wandlamp|accessoire|accessoires|decoratie|wanddecoratie|kunst|spiegel|spiegels|plant|planten|kussen|kussens|plaid|vloerkleed|tapijt|textiel|sfeer|rustig|rustige|warm|warme|koel|zacht|zachte|strak|strakke|organisch|organische|minimalistisch|minimalistische|luxe|chic|japandi|scandinavisch|scandinavische|modern|moderne|industrieel|industriële|industriele|landelijk|landelijke|hotel\s*chic|art\s*deco|klassiek|klassieke|retro|vintage|mat|glans|naturel|natuurlijk|natuurlijke|donker|donkere|lichte|aardetinten|pastel|ton\s*sur\s*ton|symmetrisch|asymmetrisch)\b/i;

  function validate(value) {
    const text = String(value || '').trim();
    if (!text) return { ok: true, value: '' };
    if (text.length > 350) return { ok: false, message: 'Houd je extra wensen korter dan 350 tekens.' };
    if (blockedPatterns.some(function (pattern) { return pattern.test(text); })) {
      return { ok: false, message: 'Gebruik dit veld alleen voor normale interieur- en stijlwensen voor de slaapkamer. Mensen, dieren, tekst en andere scènes zijn niet toegestaan.' };
    }
    if (!stylePattern.test(text)) {
      return { ok: false, message: 'Beschrijf hier alleen visuele interieurwensen, zoals kleuren, materialen, verlichting, wanden, vloer of accessoires.' };
    }
    return { ok: true, value: text };
  }

  function showError(message) {
    field.setAttribute('aria-invalid', 'true');
    if (inlineError) inlineError.textContent = message;
    if (generalMessage) generalMessage.textContent = message;
  }

  function clearError() {
    field.removeAttribute('aria-invalid');
    if (inlineError) inlineError.textContent = '';
  }

  form.addEventListener('submit', function (event) {
    const result = validate(field.value);
    if (!result.ok) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(result.message);
      field.focus();
      return;
    }
    field.value = result.value;
    clearError();
  }, true);

  field.addEventListener('input', function () {
    if (field.getAttribute('aria-invalid') !== 'true') return;
    const result = validate(field.value);
    if (result.ok) clearError();
  });

  document.addEventListener('bbm:style-rejected', function (event) {
    const message = event && event.detail && event.detail.message
      ? event.detail.message
      : 'Gebruik dit veld alleen voor normale interieur- en stijlwensen voor de slaapkamer.';
    showError(message);
    field.focus();
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  const nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    try {
      const target = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      if (webhook && target === webhook && init && init.body instanceof URLSearchParams) {
        const result = validate(field.value);
        init.body.set('style_details', result.ok ? result.value : '');
      }
    } catch (_) {}
    return nativeFetch(input, init);
  };
})();
